import React from 'react';
import PropTypes from 'prop-types';
import Switch from '@mui/material/Switch';

import texts from './texts.json';
import {
  TouchpointContainer,
  Row,
  StyledFormControlLabel,
  SectionDescription,
  OfferTitle,
} from './styles';
import OfferForm from './OfferForm';
import { isCoachingProduct } from './utils';

/**
 * The checkout pre-enroll of one upsell strategy: whether a client buying the challenge on Avida checkout is offered
 * the 1:1 below, starting when the challenge ends. Only 1:1 products are offered — the server only
 * pre-enrolls into coaching.
 */
const CheckoutPreEnrollEditor = ({
  checkoutPreEnroll,
  onChange,
  products,
  currency,
}) => (
  <TouchpointContainer>
    <Row>
      <StyledFormControlLabel
        control={(
          <Switch
            checked={!!checkoutPreEnroll.enabled}
            onChange={(event) => onChange({ enabled: event.target.checked })}
            color="primary"
          />
        )}
        label={texts.checkoutPreEnrollTitle}
      />
      <SectionDescription>
        {checkoutPreEnroll.enabled ? texts.checkoutPreEnrollDescription : texts.checkoutPreEnrollDisabled}
      </SectionDescription>
    </Row>
    {!!checkoutPreEnroll.enabled && (
      <>
        <OfferTitle>{texts.offerTitle}</OfferTitle>
        <OfferForm
          offer={checkoutPreEnroll.offer}
          onChange={(offer) => onChange({ offer })}
          products={products.filter(isCoachingProduct)}
          currency={currency}
          hasOriginalPrice
        />
      </>
    )}
  </TouchpointContainer>
);

CheckoutPreEnrollEditor.propTypes = {
  checkoutPreEnroll: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  products: PropTypes.array.isRequired,
  currency: PropTypes.string.isRequired,
};

export default CheckoutPreEnrollEditor;
